import { format, addDays } from 'date-fns';
import { DAYS } from '../types';

export const CalendarHeader = ({ currentWeek }: { currentWeek: Date }) => (
  <div className="flex border-b sticky top-0 bg-white z-10" role="rowgroup">
    <div className="w-20 flex-shrink-0 border-r" role="columnheader" />
    {[1, 2, 3, 4, 5, 6, 0].map((offset) => {
      const day = addDays(currentWeek, offset);
      return (
        <div
          key={offset}
          className="flex-1 border-r p-2 text-center"
          role="columnheader"
        >
          <div className="font-semibold">{DAYS[day.getDay()]}</div>
          <div className="text-sm text-gray-500">{format(day, 'MMM d')}</div>
        </div>
      );
    })}
  </div>
); 